<template>
  <div>
    <vs-popup
      class="holamundo"
      :title="$t('AddBundleStock')"
      :active.sync="isSidebarActiveLocal"
      @close="closeBundleProductPopup"
      @cancel="closeBundleProductPopup"
    >
      <div style="min-height: 400px">
        <b-row>
          <b-col>
            <vs-card>
              <b-row v-if="ROLE != 'Company'">
                <b-col cols="4" align-self="center">
                  <b-form-group
                    :label="'* ' + $t('Customer')"
                    label-for="h-first-name"
                    style="font-weight: 600"
                  >
                  </b-form-group>
                </b-col>
                <b-col cols="8">
                  <v-select
                    color="danger"
                    v-model="customer"
                    :options="customer_choices"
                    size="small"
                    label="name"
                    autocomplete
                    ref="selectElement"
                    name="customer"
                    v-validate="'required'"
                  >
                  </v-select>

                  <span class="text-danger text-sm" v-show="errors.has('customer')">{{
                    errors.first("customer")
                  }}</span>
                </b-col>
              </b-row>
              <b-row style="margin-top: 8px">
                <b-col cols="4" align-self="center">
                  <b-form-group
                    :label="$t('MarketPlaceName')"
                    label-for="h-first-name"
                    style="font-weight: 600"
                  >
                  </b-form-group>
                </b-col>
                <b-col cols="8">
                  <v-select
                    v-model="marketPlaceName"
                    :options="mpOPTION"
                    autocomplete
                    name="marketPlaceName"
                    :taggable="true"
                  >
                  </v-select>
                </b-col>
              </b-row>
              <b-row style="margin-top: 8px">
                <b-col cols="4" align-self="center">
                  <b-form-group
                    :label="$t('MarketPlaceBarcode')"
                    label-for="h-first-name"
                    style="font-weight: 600"
                  >
                  </b-form-group>
                </b-col>
                <b-col cols="8">
                  <vs-input
                    size="small"
                    v-model="marketPlaceBarcode"
                    type="text"
                    class="w-full"
                    name="marketPlaceBarcode"
                  />
                </b-col>
              </b-row>
              <b-row style="margin-top: 8px">
                <b-col cols="4" align-self="center">
                  <b-form-group
                    :label="$t('ProductBarcode')"
                    label-for="h-first-name"
                    style="font-weight: 600"
                  >
                  </b-form-group>
                </b-col>
                <b-col cols="8">
                  <vs-input
                    size="small"
                    v-model="productBarcode"
                    type="text"
                    class="w-full"
                    name="productBarcode"
                  />
                </b-col>
              </b-row>
              <b-row style="margin-top: 8px">
                <b-col cols="4" align-self="center">
                  <b-form-group
                    :label="$t('ProductName')"
                    label-for="h-first-name"
                    style="font-weight: 600"
                  >
                  </b-form-group>
                </b-col>
                <b-col cols="8">
                  <vs-input
                    size="small"
                    v-model="productName"
                    type="text"
                    class="w-full"
                    name="productName"
                  />
                </b-col>
              </b-row>
              <b-row style="margin-top: 8px">
                <b-col cols="4" align-self="center">
                  <b-form-group
                    :label="$t('ProductSku')"
                    label-for="h-first-name"
                    style="font-weight: 600"
                  >
                  </b-form-group>
                </b-col>
                <b-col cols="8">
                  <vs-input
                    size="small"
                    v-model="productSku"
                    type="text"
                    class="w-full"
                    name="productSku"
                  />
                </b-col>
              </b-row>
              <b-row style="margin-top: 8px">
                <b-col cols="4" align-self="center">
                  <b-form-group
                    :label="$t('ProductQuantity')"
                    label-for="h-first-name"
                    style="font-weight: 600"
                  >
                  </b-form-group>
                </b-col>
                <b-col cols="8">
                  <vs-input
                    size="small"
                    v-model="productQuantity"
                    type="number"
                    class="w-full"
                    name="productQuantity"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('productQuantity')"
                    >{{ errors.first("productQuantity") }}</span
                  >
                </b-col>
              </b-row>
            </vs-card>
          </b-col>
        </b-row>
        <div class="items-center pl-6 mt-0 mb-0">
          <b-row align-h="end">
            <b-col cols="3" md="auto" style="padding: 0px">
              <b-button
                class="bg-danger"
                style="border-color: white"
                v-on:click="closeBundleProductPopup"
              >
                <Icon
                  icon="material-symbols:cancel-outline"
                  style="margin-right: 5px"
                  width="20"
                  height="20"
                />{{ $t("Cancel") }}
              </b-button>
            </b-col>
            <b-col cols="3" md="auto">
              <b-button
                class="bg-primary"
                style="border-color: white"
                v-on:click="sendData()"
              >
                <Icon
                  icon="material-symbols:save-outline"
                  style="margin-right: 5px"
                  width="20"
                  height="20"
                />{{ $t("Save") }}
              </b-button>
            </b-col>
          </b-row>
        </div>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import i18nData from "../../i18n/i18nData";
import vSelect from "vue-select";
import { Icon } from "@iconify/vue2";
import { uuid } from "vue-uuid";
import { Validator } from "vee-validate";
export default {
  components: { Icon, vSelect, AgGridVue },
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      default: () => {},
    },
  },
  data() {
    return {
      BundleProductId: "",
      marketPlaceName: "",
      marketPlaceBarcode: "",
      productBarcode: "",
      productSku: "",
      productName: "",
      productQuantity: 0,
      customer: "",
      ROLE: this.$store.state.AppActiveUser.ROLE,
      customer_choices: [],
      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
      },
      productBundleList: [],
    };
  },
  methods: {
    sendData() {
      this.productBundleList = [];
      var createdId = uuid.v4();
      this.fixData({
        bundleProductId: this.data.BundleProductId ? this.BundleProductId : createdId,
        marketPlaceName: this.marketPlaceName,
        marketPlaceBarcode: this.marketPlaceBarcode,
        productBarcode: this.productBarcode ? this.productBarcode : "",
        productSku: this.productSku ? this.productSku : "",
        productName: this.productName ? this.productName : "",
        productQuantity: this.productQuantity,
        companyId: this.customer.value,
        companyName: this.customer.name,
      });  
      if (this.data.BundleProductId) {
        this.submitData("updateStockBundle", this.productBundleList[0]);
      } else this.submitData("addStockBundle", this.productBundleList);
    },
    fixData(item) { 
      this.productBundleList.push({
        bundleProductId: item.bundleProductId,
        marketPlaceName: item.marketPlaceName,
        marketPlaceBarcode: item.marketPlaceBarcode,
        productBarcode: item.productBarcode,
        productSku: item.productSku,
        productName: item.productName,
        productQuantity: item.productQuantity,
        companyId:
          this.ROLE == "Company" ? this.activeUserInfo.companyid : item.companyId,
        companyName:
          this.ROLE == "Company" ? this.activeUserInfo.userName : item.companyId,
      });
    },
    submitData(method, item) {
      const vs = this.$vs;
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store
            .dispatch("stock/" + method, item)
            .then((response) => {
              try {
                if (response.data.success == true) {
                  vs.notify({
                    text: response.data.message,
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "success",
                    position: "top-center",
                  });
                  this.closeBundleProductPopup();
                } else {
                  vs.notify({
                    text: response.data.message.toString(),
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "danger",
                    position: "top-center",
                  });
                }
              } catch (error) {
                console.log(error);
              }
            })
            .catch((error) => {
              return new Promise((resolve, reject) => {
                resolve(false);
              });
            });
        } else {
          vs.notify({
            text: this.$t("Validate"),
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-center",
          });
        }
      });
    },
    closeBundleProductPopup() {
      this.isSidebarActiveLocal = false;
    },

    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },

    getCustomerList(id, popup) {
      this.customerListOption = [];
      this.customer_choices = [];
      this.customerListOption = this.companydata;
      this.customerListOption.forEach((val, index) => {
        this.customer_choices.push({ value: val.CompanyId, name: val.CompanyName });
      });
    },
    getMpNameOptions() {
      this.mpNameListOption = [];
      this.mpOPTION = [];
      this.mpNameListOption = this.mpNameList;
      this.mpOPTION = Object.values(this.mpNameListOption);
    },
  },
  created() {
    this.getMpNameOptions();
    this.getCustomerList();
		
  },
  watch: {
    companydata(val) {
      this.getCustomerList();
      return val;
    },
    data(val) {
      this.BundleProductId = val.BundleProductId;
      this.marketPlaceName = val.MarketPlaceName;
      this.marketPlaceBarcode = val.MarketPlaceBarcode;
      this.productBarcode = val.ProductBarcode;
      this.productName = val.ProductName;
      this.productSku = val.ProductSku;
      this.productQuantity = val.ProductQuantity;
      this.customer = { name: val.CompanyName, value: val.CompanyId };
      return val;
    },
    isSidebarActive(val) {
      if (val == true) {
        const dict = {
          custom: {
            customer: {
              required: this.$t("customerNameRequired"),
              alpha: this.$t("customerNameRequired"),
            },

            brand: {
              required: this.$t("brandRequired"),
              alpha: this.$t("brandRequired"),
            },
          },
        };
        Validator.localize("en", dict);
      }
      return val;
    },
    mpNameList(val) {
      this.getMpNameOptions();
      return val;
    },
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
    mpNameList: {
      get() {
        return this.$store.state.order.MpNameList;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
    companydata: {
      get() {
        return this.$store.state.customer.Customer;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    stockGroupBundleProduct: {
      get() {
        return this.$store.state.stock.StockGroupBundleProduct;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    localeText() {
      return i18nData[this.$i18n.locale];
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
  },
};
</script>
